import React from 'react';

export default ({
  handleSortClick,
  order,
  sortedBy,
  isOilDashboard,
  tableColumnsWidths,
  isWithPaymentStatus,
  isWithCertificationStatus,
  user,
}) => {
  function createClasses(id) {
    if (sortedBy === id) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div
        className={`list-scene__table-header-element ${createClasses('code')} _width_pc_12`}
        onClick={handleSortClick('code')}
      >
        <div>ID</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element list-scene__table-row-element_place_filler
      ${createClasses('name')}`}
        onClick={handleSortClick('name')}
      >
        <div>Inspector Company Name</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/InspectorDashboardScene/TableHeader.jsx